import * as React from 'react'

/** Context that lets deeply-nested children close the sheet without prop drilling. */
export const SheetCloseContext = React.createContext<(() => void) | null>(null)

/** Context for scoping sheet portals to a container element instead of document.body. */
export const SheetContainerContext = React.createContext<HTMLElement | null>(null)

export function useSheetClose() {
  return React.useContext(SheetCloseContext)
}
